import './index.css';
import './styles/gradient.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './contexts/ToastContext';
import { DataProvider } from './contexts/DataContext';
import { AuthProvider } from './contexts/AuthContext';
import { LogProvider } from './contexts/LogContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { WalletProvider } from './contexts/WalletContext';

// --- TEMPORARY DEBUGGING --- 
console.log('[DEBUG] VITE_PAYPAL_CLIENT_ID:', import.meta.env.VITE_PAYPAL_CLIENT_ID);
// --- END TEMPORARY DEBUGGING --- 

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Router>
      <ErrorBoundary>
        <ToastProvider>
          <DataProvider>
            <AuthProvider>
              <LogProvider>
                <SubscriptionProvider>
                  <WalletProvider>
                    <App />
                  </WalletProvider>
                </SubscriptionProvider>
              </LogProvider>
            </AuthProvider>
          </DataProvider>
        </ToastProvider>
      </ErrorBoundary>
    </Router>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registered: ', registration);
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError);
    });
  });
}
